import { useMutation, useQueryClient } from "@tanstack/react-query";
import { downloadConsolidateByHourTypeOverTimeReport } from "../api/overtimeScheduleApi";
import { OvertimeWorkedAndScheduledPerPeriodRequest } from "../models/OvertimeSchedule";

export const useDownloadConsolidateByHourTypeOvertimeReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      body: Omit<
        OvertimeWorkedAndScheduledPerPeriodRequest,
        "preliquidateTypeId"
      >,
    ) => downloadConsolidateByHourTypeOverTimeReport(body),
  });
};
